import axiosApi, { setHeader } from "api/root.api";

export const getMaterialLib = async (size, page) => {
  const urlEnd = `/editor/asset/v1/list?size=${size}&page=${page}&sort=dateCreated,desc`;
  const response = await axiosApi.get(urlEnd);
  const result = response.data;
  return result;
};
